/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { Chip } from '@mui/material'

import useT from '@/i18n/useT'

type ReviewVerificationChipsProps = {
  isVerified: boolean
  verifiedByEmail?: string | null
  verifiedAt?: string | null
}

function ReviewVerificationChips({
  isVerified,
  verifiedByEmail = null,
  verifiedAt = null,
}: ReviewVerificationChipsProps) {
  const { t } = useT()

  return (
    <>
      <Chip
        variant="outlined"
        color={isVerified ? 'success' : 'default'}
        label={
          isVerified
            ? t('review.metadata.verified', 'Verified')
            : t('review.metadata.notVerified', 'Not verified')
        }
      />
      {isVerified && verifiedByEmail ? (
        <Chip
          variant="outlined"
          label={t('review.metadata.verifiedBy', {
            email: verifiedByEmail,
            defaultValue: `Verified by ${verifiedByEmail}`,
          })}
        />
      ) : null}
      {isVerified && verifiedAt ? (
        <Chip
          variant="outlined"
          label={new Date(verifiedAt).toLocaleString()}
        />
      ) : null}
    </>
  )
}

export default ReviewVerificationChips
